import { inject, observer } from 'mobx-react';
import React from 'react';
import { Button } from 'reactstrap';
import { Link } from "react-router-dom";
import { injectIntl, intlShape } from "react-intl";

import ConfigStore from "../../../../store/ConfigStore";
import TranslationStore from "../../../../store/TranslationStore";
import UIStore from "../../../../store/UIStore";
import globalTranslations from "../../../../i18n/globalTranslations";
import Hamburger from "../../../common/Hamburger";
import Icon from "../../../common/Icon";
import { modelOf } from "../../../../prop-types";
import MobileNavigationTab from "../../../../types/MobileNavigationTab";
import MobileNavigationButton from "../../../header/MobileNavigationButton";

const CheckoutHeaderMobileNavigation = ({
  configStore,
  translationStore,
  uiStore,
  intl,
}) => {
  const getDefaultMobileMenuTab = () => {
    return MobileNavigationTab.INFO;
  };

  const getAccountMobileNavigation = () => {
    return (
      <MobileNavigationButton
        tab={MobileNavigationTab.ACCOUNT}
        className="ml-auto text-uppercase CommonNavigation__icons"
        ariaLabel={intl.formatMessage(globalTranslations.myAccountTitle)}
      >
        <Icon name="user" className="fa-2x" />
      </MobileNavigationButton>
    );
  };

  const mobileLogo = translationStore.mobileLogo;

  return (
    <div className="CheckoutHeaderMobileNavigation">
      <div className="CheckoutHeaderMobileNavigation__mobile-left">
        <MobileNavigationButton
          tab={getDefaultMobileMenuTab()}
          forceClose={uiStore.mobileNavigation.isOpen}
          ariaLabel={intl.formatMessage(globalTranslations.seeCategoriesNavi)}
        >
          <Hamburger active={uiStore.mobileNavigation.isOpen} />
        </MobileNavigationButton>
        <div className="CommonNavigation__mobile-home">
            <Link to="/">
              <Button
                color="plain"
                className="CommonNavigation__icons"
                aria-label={intl.formatMessage(globalTranslations.homeTitle)}
              >
                {mobileLogo.length > 0 ? (
                  <img
                    className="CommonNavigation__mobile-logo-img"
                    alt={configStore.store.name}
                    src={mobileLogo[0].image_path}
                    width={mobileLogo[0].width}
                    height={mobileLogo[0].height}
                  />
                ) : (
                  <Icon name="home" className="fa-2x" />
                )}
              </Button>
            </Link>
        </div>
      </div>
      <div className="CheckoutHeaderMobileNavigation__mobile-right">
        {getAccountMobileNavigation()}
      </div>
    </div>
  );
};

CheckoutHeaderMobileNavigation.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  translationStore: modelOf(TranslationStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  intl: intlShape.isRequired,
};

export default inject(
  'configStore',
  'translationStore',
  'uiStore',
)(injectIntl(observer(CheckoutHeaderMobileNavigation)));
